import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import usePageTitle from '../hooks/usePageTitle';

const About = () => {
  usePageTitle('À propos');
  return (
    <div className="min-h-screen flex flex-col bg-gray-100 dark:bg-gray-900 text-black dark:text-white">
      <Header />
      <div className="flex-1 container mx-auto py-8 px-4">
        <h1 className="text-2xl font-bold mb-4">À propos</h1>
        <p className="mb-4">PulseCIO est un outil développé pour faciliter la gestion et le partage rapide de messages professionnels. Notre objectif est de fournir une interface simple et efficace pour centraliser des messages, notes et tâches, adaptée à tous types d'organisations : grandes entreprises (DSI & CIO Office), PME, associations et particuliers.</p>

        <h2 className="font-semibold mt-4">Notre vision</h2>
        <p className="mb-2">Nous croyons que toute organisation, quelle que soit sa taille, mérite des outils performants pour structurer sa communication et gagner en productivité. PulseCIO unifie ces besoins dans une plateforme accessible et sécurisée.</p>

        <h2 className="font-semibold mt-4">Auteur</h2>
        <p className="mb-2">Ce projet est conçu et maintenu par Mathieu Lalande. L'activité est exercée sous le statut d'auto-entreprise (micro-entrepreneur). L'auteur est responsable du contenu publié sur ce site.</p>

        <h2 className="font-semibold mt-4">Statut</h2>
        <p className="mb-2">Statut juridique : auto-entreprise (micro-entrepreneur). Pas de capital social de départ.</p>

        <p className="mt-6"><Link to="/" className="text-accent underline">Retour à l'accueil</Link></p>
      </div>
      <Footer />
    </div>
  );
};

export default About;
